(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

/**
 * Function for the navigation through the slider
 */
var delay = function () {
  var timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
}();

(function ($) {
  var InsSlider = function InsSlider(element) {
    var sliderWidth = $(element).find('.ins-img-slide')[0];
    sliderWidth = sliderWidth.clientWidth;
    var containerWidth = $(element)[0].clientWidth;

    if (containerWidth >= sliderWidth) {
      $(element).find('#arrright').addClass("disablearr");
    }

    function calcWidth() {
      var slideWidth = 0;
      var arrImgContainer = $(element).find('.img-container');
      arrImgContainer.each(function (index, value) {
        slideWidth += value.clientWidth;
      });
      slideWidth = slideWidth / arrImgContainer.length;
      return {
        "slideWidth": slideWidth,
        "sliderWidth": sliderWidth,
        "containerWidth": containerWidth
      };
    }

    $(element).find('#arrleft').click(function (e) {
      var widths = calcWidth();
      var curentLeft = $(element).find('.ins-img-cont')[0].scrollLeft;
      var stepSize = 280;

      if (stepSize > widths["containerWidth"]) {
        stepSize = widths["containerWidth"];
      }

      var offsetLeft = curentLeft - stepSize;

      if (offsetLeft > 10) {
        $(element).find('#arrright').removeClass("disablearr");
        var option = {
          left: offsetLeft,
          behavior: 'smooth'
        };
        $(element).find('.ins-img-cont')[0].scrollTo(option);
      } else {
        e.currentTarget.classList.add("disablearr");
        $(element).find('#arrright').removeClass("disablearr");
        var option = {
          left: 0,
          behavior: 'smooth'
        };
        $(element).find('.ins-img-cont')[0].scrollTo(option);
      }
    });
    $(element).find('#arrright').click(function (e) {
      var widths = calcWidth();
      var curentLeft = $(element).find('.ins-img-cont')[0].scrollLeft;
      var stepSize = 280;

      if (stepSize > widths["containerWidth"]) {
        stepSize = widths["containerWidth"];
      }

      var offsetLeft = curentLeft + stepSize;

      if (offsetLeft < widths["sliderWidth"] - widths["containerWidth"] - 10) {
        $(element).find('#arrleft').removeClass("disablearr");
        var option = {
          left: offsetLeft,
          behavior: 'smooth'
        };
        $(element).find('.ins-img-cont')[0].scrollTo(option);
      } else {
        e.currentTarget.classList.add("disablearr");
        $(element).find('#arrleft').removeClass("disablearr");
        $(element).find('.ins-img-cont')[0].scrollTo({
          left: widths["sliderWidth"] - widths["containerWidth"],
          behavior: 'smooth'
        });
      }
    });
    $(element).find('.ins-img-cont').scroll(function (e) {
      var curentLeft = $(element).find('.ins-img-cont')[0].scrollLeft;

      if (curentLeft > 0) {
        $(element).find('#arrleft').removeClass("disablearr");
      } else {
        $(element).find('#arrleft').addClass("disablearr");
      }

      if (curentLeft >= $(element).find('.ins-img-cont').prop("scrollWidth") - $(element).find('.ins-img-cont').prop("clientWidth") - 2) {
        $(element).find('#arrright').addClass("disablearr");
      } else {
        $(element).find('#arrright').removeClass("disablearr");
      }
    });
    return this;
  };

  $.fn.insSlider = function () {
    return this.each(function () {
      var element = $(this);

      if (element.data('insSlider')) {
        element.data('insSlider', null);
      }

      var insSlider = new InsSlider(this);
      element.data('insSlider', insSlider);
    });
  };
})(jQuery);

jQuery(window).load(function () {
  jQuery('.ins-slider').insSlider();
});
jQuery(document).ready(function ($) {
  var modal = document.getElementById("myModal");
  var modalImg = document.getElementById("img01");
  var captionText = document.getElementById("caption");
  var burgerMenu = document.getElementsByClassName("burgerMenu")[0];
  $(document).on('click', '.slider-img', function (e) {
    modal.style.display = "block";
    modalImg.src = this.src;
    var caption = e.target.parentElement.getElementsByClassName("descript")[0];
    captionText.innerHTML = caption != undefined ? caption.innerHTML : "";
    var arrows = document.getElementsByClassName("arr");
    Array.prototype.forEach.call(arrows, function (ele) {
      if (!ele.classList.contains("disablearr")) {
        ele.style.display = "none";
      }
    });
    burgerMenu.style.display = "none";
  });
  $(document).on('click', '#myModal', function (e) {
    if (e.target.classList.contains("modal-content") || e.target.id === "caption") {
      return;
    }

    modal.style.display = "none";
    var arrows = document.getElementsByClassName("arr");
    Array.prototype.forEach.call(arrows, function (ele) {
      if (!ele.classList.contains("disablearr")) {
        ele.style.display = "";
      }
    });
    burgerMenu.style.display = "";
  }); // Get the <span> element that closes the modal

  var span = document.getElementsByClassName("close")[0]; // When the user clicks on <span> (x), close the modal

  span.onclick = function () {
    modal.style.display = "none";
    var arrows = document.getElementsByClassName("arr");
    Array.prototype.forEach.call(arrows, function (ele) {
      if (!ele.classList.contains("disablearr")) {
        ele.style.display = "";
      }
    });
    burgerMenu.style.display = "";
  };
});

},{}]},{},[1]);
